import { render, staticRenderFns } from "./FirmaComponent.vue?vue&type=template&id=7f77767e"
import script from "./FirmaComponent.vue?vue&type=script&lang=js"
export * from "./FirmaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports